import { useId, forwardRef, HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import styles from "../Field.module.css";

const FieldTextarea = forwardRef<HTMLTextAreaElement, HTMLProps<HTMLTextAreaElement>>(({
	name,
	rows = 6,
	placeholder,
	className,
    ...props
}, ref) => {
	const id = useId();
	return (
		<textarea
			ref={ref}
			id={id}
			className={cn(styles.FieldTextarea, className)}
			name={name}
			placeholder={placeholder}
			rows={rows}
			{...props}
		/>
	)
});

export default FieldTextarea;